import { useState } from "react";
import { EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";

export const useTextEditor = () => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  const onEditorStateChange = (editorState, setValue) => {
    if (setValue) {
      setValue(
        "descripcion",
        draftToHtml(convertToRaw(editorState.getCurrentContent()))
      );
    }
    setEditorState(editorState);
  };

  return {
    editorState,
    onEditorStateChange,
    setEditorState,
  };
};

export default useTextEditor;